<!-- 审核查看 -->

<template>
  <div class="admin-1">
    <div class="headBar">
      <span>{{ querys.pvcName }}</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ querys.pressName }}</span>
    </div>
    <CommonTab
      ref="mainTab"
      :cancelFlag="false"
      v-if="wSat == 1"
      :organization="querys.pressName"
      :pressType="querys.pressType"
      :defaultYear="querys.year1"
      :pressDat="resDat"
      :selYears="selYearRecord"
      @valChangeSearch="valChangeSearch"
      role="show" />

    <div class="headBar">
      <span>出版单位信息统计</span>
    </div>
    <div class="progressTab" style="margin-left: 30px; font-size: 14px" v-if="querys.pressType == 1">
      <span style="font-weight: bold; color: red">以下情况数字会进行标红</span><br />
      <span> 1、领导班子成员持证上岗率：</span><span>上岗率低于50%</span>

      <br />
      <span> 2、出版物数量：</span>
      2023 + 2024年出版物数量小于10

      <br />
      <span> 3、编辑人员人数：</span>
      取得国家出版专业技术人员资格的编辑人员，其人数小于10人

      <br />
      <span> 4、出版专业中级职称以上人数：</span>
      具有中级以上出版专业职业资格人数小于5人

      <!-- <br />
      <span> 5、出版许可证：</span>
      有效期在2025年6月30号之前 -->
    </div>
    <!--zym.电子-->
    <div class="progressTab" style="margin-left: 30px; font-size: 14px" v-if="querys.pressType == 2">
      <span style="font-weight: bold; color: red">以下情况数字会进行标红</span><br />
      <span> 1、领导班子成员持证上岗率：</span><span>上岗率低于50%</span>

      <br />
      <span> 2、出版专业中级职称以上人数：</span>
      具有中级以上出版专业职业资格人数小于2人

      <!-- <br />
      <span> 3、出版许可证：</span>
      有效期在2025年6月30号之前 -->
    </div>
    <div class="informationStatic" style="padding: 10px 50px 50px 50px">
      <div class="left">
        <div class="multiple">
          <p>第一年度出版物数量</p>
          <span
            :class="
              querys.pressType == 1 && publishUnitJson.firstYearDeliverNum + publishUnitJson.secondYearDeliverNum < 10
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.firstYearDeliverNum }}</span
          >
        </div>
        <div class="multiple">
          <p>第二年度出版物数量</p>
          <span
            :class="
              querys.pressType == 1 && publishUnitJson.firstYearDeliverNum + publishUnitJson.secondYearDeliverNum < 10
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.secondYearDeliverNum }}</span
          >
        </div>
        <!-- <div class="multiple">
          <p>出版许可证</p>
          <span
            :class="
              publishUnitJson.pqualificationvalid && publishUnitJson.pqualificationvalid == '已过期' ? 'highlight' : ''
            "
            >{{ publishUnitJson.pqualificationvalid }}</span
          >
        </div> -->
      </div>
      <div class="right">
        <div class="multiple">
          <p>领导班子成员持证上岗率（%）</p>
          <span :class="publishUnitJson.workerProportion < 50 ? 'highlight' : ''">{{
            publishUnitJson.workerProportion
          }}</span>
        </div>
        <div class="multiple" v-if="querys.pressType == 1">
          <p>取得国家出版专业技术人员资格的编辑人员数</p>
          <!-- highlight -->
          <span :class="querys.pressType == 1 && publishUnitJson.zjCertificate < 10 ? 'highlight' : ''">{{
            publishUnitJson.zjCertificate
          }}</span>
        </div>
        <div class="multiple">
          <p>出版专业中级职称以上人数</p>
          <!-- highlight -->
          <span
            :class="
              (querys.pressType == 1 && publishUnitJson.zjCertificateWorkers < 5) ||
              (querys.pressType == 2 && publishUnitJson.zjCertificateWorkers < 2)
                ? 'highlight'
                : ''
            "
            >{{ publishUnitJson.zjCertificateWorkers }}</span
          >
        </div>
      </div>
    </div>

    <div class="progressTab">
      <div class="headBar">
        <span>审核历史</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" width="220" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" width="120" label="状态" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("statuscbs") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" min-width="300" label="审核意见" align="center"></el-table-column>
        <el-table-column prop="pubNumber" width="120" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="150" label="操作时间" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="querys.pressState == 1" class="subArea">
      <div class="headBar">
        <span>审核意见</span>
      </div>
      <div class="radioBx">
        <el-radio-group v-model="params.status">
          <el-radio :label="'1'">通过</el-radio>
          <el-radio :label="'2'">暂缓登记</el-radio>
          <el-radio :label="'5'">注销或拟注销</el-radio>
          <el-radio :label="'4'">撤销</el-radio>
          <!-- <el-radio :label="'3'">退回</el-radio> -->
          <!-- <el-radio :label="'22'">暂缓登记</el-radio> -->
        </el-radio-group>
        <el-input
          v-model="params.message"
          v-if="
            params.status == 1 || params.status == 2 || params.status == 3 || params.status == 5 || params.status == 4
          "
          type="textarea"
          :rows="5"
          placeholder="请填写意见"></el-input>
      </div>
    </div>
    <div class="subLine">
      <el-button @click="goBack">返回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goBackExamsave" type="warning">退回</el-button>
      <el-button v-if="querys.pressState == 1" @click="goExamsave" type="danger">审 核</el-button>
    </div>
  </div>
</template>

<script>
import CommonTab from "@/views/components/SPEC/SpecCommonTab";
import { writeReadTime, publishStatic } from "@/api/provinceRole/provinceRole";

import { adminExam } from "@/api/adminRole/adminRole";
import { getPressList, sUpdate0, getSelYearRecord } from "@/api/pressRole/pressRole";
import { successiveHistory } from "@/api/provinceRole/provinceRole";
export default {
  components: {
    CommonTab,
  },
  data() {
    return {
      emType: "",
      emId: "",
      emState: "",

      querys: {
        pressType: "",
        pressId: "",
        pressName: "",
        pressState: "",

        examId: "",
        pvcName: "",
        year1: "",
      },

      wSat: 0,

      resDat: [{}],
      selYearRecord: [{}],
      params: {
        ids: [],
        type: "",
        status: "1",
        message: "",
        pubNumber: "",
      },

      //  审核历史
      tabDat: [],

      publishUnitJson: {},
    };
  },

  filters: {
    tansStr: function (dat, code) {
      if (code == "state" || code == "statuscbs") {
        console.log("state=", dat.flowName, "  ", dat.status);
        if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            21: "暂缓登记",
            // 22: "暂缓登记",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
          };
          if (code == "statuscbs") {
            return map[dat.status];
          }
          //   console.log("测试整改：", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓登记",
            3: "退回",
            21: "暂缓登记",
            // 22: "暂缓登记",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date" || !dat["checkdAt"]) {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
  },

  methods: {
    goBackExamsave: function () {
      const msg = "请填写意见！";
      if ((this.params.message || "").length == 0) {
        this.$message.error(msg);
      } else {
        let msg = '确定已查看完毕，并对该单位核验材料批以 "退回" 处理吗？';
        let vm = this;
        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.params.ids.push(this.$route.query.examId);
            let paramsNew = { ...this.params, status: "3" };
            const loading = vm.$loading({
              lock: true,
              text: "处理中",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
            });
            adminExam(paramsNew).then((response) => {
              loading.close();
              let tipCode = response.payload.tipCode;
              let tipMessage = response.payload.tipMessage;
              if (tipCode == "fail") {
                this.$message({
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  message: tipMessage,
                  type: "success",
                });
                vm.goBack();
              }
            });
          })
          .catch(() => {});
      }
    },
    goExamsave: function () {
      //   let transArr = ["", "通过", "暂缓", "退回", "撤销", "注销"];
      let transArrMap = {
        0: "",
        1: "通过",
        2: "暂缓登记",
        3: "退回",
        4: "撤销",
        5: "注销或拟注销",
        // , 22: "暂缓登记"
      };
      let msg = '确定已查看完毕，并对该单位核验材料批以 "' + transArrMap[this.params.status] + '" 处理吗？';
      let vm = this;
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.params.ids.push(this.$route.query.examId);
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          adminExam(this.params).then((response) => {
            loading.close();
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.tipMessage;
            if (tipCode == "fail") {
              this.$message({
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: tipMessage,
                type: "success",
              });
              vm.goBack();
            }
          });
        })
        .catch(() => {});
    },

    goBack: function () {
      let pathStr = "audio_fexam";
      if (this.$route.query.pressType == 2) {
        pathStr = "elect_fexam";
      }

      if (this.$route.query.pressState == 3) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: pathStr,
          query: {
            pvcId: this.$route.query.pvcId,
          },
        });
      }
    },
    valChangeSearch: function (val) {
      this.gPlist(val);
    },
    // zym.审核历史
    historyRecord: function () {
      successiveHistory({ examineId: this.querys.mtId, year1: this.querys.year1 }).then((response) => {
        this.tabDat = response.fFlowTaskList;
        // for (let item of response.fFlowTaskList) {
        // 	if (item.examineName) {
        // 		this.tabDat.push(item);
        // 	}
        // }
        // 查找最后的省局审核意见
        let tabDatProvince = (this.tabDat || []).filter((item) => {
          return item.flowName == "国家新闻出版署";
        });
        if (tabDatProvince && tabDatProvince.length > 0) {
          let last = tabDatProvince[tabDatProvince.length - 1];
          this.params.status = last.status == "0" ? "1" : last.status + "";
          this.params.message = last.examineMessage;
        } else {
          this.params.status = "1";
          this.params.message = "";
        }
      });
    },
    gPlist: function (year) {
      getPressList({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year,
      }).then((response) => {
        let vm = this;
        vm.wSat = 1;
        this.resDat.splice(0, 1, response);
        console.log(this.resDat);
      });
    },

    writeReadTime: function (year) {
      writeReadTime({
        type: this.querys.pressType,
        publishId: this.querys.pressId,
        year: year,
      }).then((response) => {
        console.debug("writeReadTime: ", response);
      });
    },

    //获取出版单位各项统计信息
    getPublishStatic: function () {
      //  publishStatic().then(response => {
      publishStatic({ examineId: this.querys.mtId }).then((response) => {
        console.debug("publishStatic: ", response);
        this.publishUnitJson = response.publisherStatistics;
      });
    },
  },

  created: function () {
    this.querys = {
      pressType: this.$route.query.pressType,
      pressId: this.$route.query.pressId,
      pressName: this.$route.query.pressName,
      pressState: this.$route.query.pressState,
      mtId: this.$route.query.mtId,
      examId: this.$route.query.examId,
      pvcName: this.$route.query.pvcName,
      year1: this.$route.query.year1,
    };

    // zym.设置操作的类型
    this.params.type = this.$route.query.pressType;

    this.gPlist(this.querys.year1);

    // zym.更新审阅时间
    if (this.$route.query.updateViewDate && this.$route.query.pressState != 2) {
      this.writeReadTime(this.$route.query.year1);
    }

    getSelYearRecord({
      publishId: this.querys.pressId,
      type: this.querys.pressType,
    }).then((response) => {
      console.log("======", response);
      let arr = [{}];
      if (response.generalPublisher.length > 0) {
        for (let i in response.generalPublisher) {
          let po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
        }
      }
      this.selYearRecord = arr;
    });

    this.historyRecord();

    this.getPublishStatic();
  },
};
</script>

<style lang="scss">
.highlight {
  color: red;
}

.admin-1 {
  padding: 9px;

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;

    span {
      font-size: 14px;
    }
  }

  .progressTab {
    margin-top: 9px;
  }

  .progressTab .headBar {
    margin-bottom: 9px;
  }

  .el-textarea {
    margin-top: 20px;

    textarea {
      resize: none;
      border-radius: 0px;
    }
  }

  .radioBx {
    margin: 20px;

    .el-radio-group {
      margin-left: 12px;
    }
  }

  .subLine {
    text-align: center;
    margin: 30px 0px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .informationStatic {
    width: auto;
    overflow: hidden;
    padding: 50px;

    .inforBalance {
      font-size: 14px;
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        width: 10%;
        float: left;
        text-align: right;
      }

      span {
        float: left;
        line-height: 50px;
      }
    }

    .left,
    .right {
      float: left;
      width: 50%;
      font-size: 14px;

      .multiple {
        width: auto;
        overflow: hidden;

        p {
          float: left;
          width: 50%;
          text-align: right;
        }

        span {
          float: left;
          width: 50%;
          line-height: 50px;
          text-align: center;
        }
      }
    }

    .right {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// adminPressck.vue?6dbafdcb